import i18next from 'i18next';
/**
 * PrivacyPrinciple Integration
 * Generated by AI
 */
import { toast } from 'sonner';
// TODO: Check store import
// import { usePrivacyPrincipleStore } from '@/store/privacy-principle.store.js';
import { Logger } from '@/lib/app-log.js';

export class PrivacyPrincipleIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        /*
        const store = usePrivacyPrincipleStore.getState();
        store.setLoading(true);
        */
        try {
            const response = await this.service.getAll(params);
            
            /*
            store.setItems(response.data);
            if (response.pagination) store.setPagination(response.pagination);
            */
            
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            /* store.setError(error.message); */
            return { success: false, error: error.message };
        } finally {
            /* store.setLoading(false); */
        }
    }

    async getById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('kvkkSimpleDefinitions:privacyPrinciple.messages.createSuccess', { defaultValue: 'Privacy principle created' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('kvkkSimpleDefinitions:privacyPrinciple.messages.updateSuccess', { defaultValue: 'Privacy principle updated' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async delete(id) {
        try {
            await this.service.delete(id);
            toast.success(i18next.t('kvkkSimpleDefinitions:privacyPrinciple.messages.deleteSuccess', { defaultValue: 'Privacy principle deleted' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }
}
